export function twoWayBind(target, propName, eventName, argsPath) {
  const originalWillUpdate = target.willUpdate;
  target.willUpdate = function (changedProps) {
    originalWillUpdate?.call(this, changedProps);

    if (changedProps.has(propName)) {
      this._value = this[propName];
      this.requestUpdate();
    }
  };

  const originalConnectedCallback = target.connectedCallback;
  target.connectedCallback = function () {
    if (originalConnectedCallback) {
      originalConnectedCallback.call(this);
    }
    this.addEventListener(eventName, (e) => {
      const newValue = argsPath.split('.').reduce((obj, key) => obj[key], e);
      this[propName] = newValue;
      this._value = newValue;
      this.requestUpdate();
    });
  };
}